import apiClient from './apiClient';

// =====================================================
// MODULE-WISE CLOSING STOCK
// =====================================================

export const getModules = async () => {
  const response = await apiClient.get('/category/modules');
  return response.data;
};

export const getModuleClosingStock = async (module, params = {}) => {
  const response = await apiClient.get(`/category/closing-stock/${module}`, { params });
  return response.data;
};

// =====================================================
// SHIPMENT REQUESTS
// =====================================================

export const createShipmentRequest = async (data) => {
  const response = await apiClient.post('/category/shipment-requests', data);
  return response.data;
};

export const getShipmentRequests = async (params = {}) => {
  const response = await apiClient.get('/category/shipment-requests', { params });
  return response.data;
};

export const getShipmentRequest = async (requestId) => {
  const response = await apiClient.get(`/category/shipment-requests/${requestId}`);
  return response.data;
};

export const editShipmentRequest = async (requestId, data) => {
  const response = await apiClient.put(`/category/shipment-requests/${requestId}/edit`, data);
  return response.data;
};

export const editApprovedShipmentRequest = async (requestId, data) => {
  const response = await apiClient.put(`/category/shipment-requests/${requestId}/edit-approved`, data);
  return response.data;
};

export const revokeShipmentRequest = async (requestId, reason) => {
  const response = await apiClient.put(`/category/shipment-requests/${requestId}/revoke`, { reason });
  return response.data;
};

export const reconcileGsChildren = async (requestId) => {
  const response = await apiClient.post(`/category/shipment-requests/${requestId}/reconcile-gs-children`);
  return response.data;
};

export const findMissingGsChildren = async () => {
  const response = await apiClient.get('/category/gs-reconcile/missing-children');
  return response.data;
};

export const approveShipmentRequest = async (requestId, data) => {
  const response = await apiClient.put(`/category/shipment-requests/${requestId}/approve`, data);
  return response.data;
};

export const rejectShipmentRequest = async (requestId, remarks) => {
  const response = await apiClient.put(`/category/shipment-requests/${requestId}/reject`, null, { 
    params: { remarks } 
  });
  return response.data;
};

export const confirmShipment = async (requestId, remarks) => {
  const response = await apiClient.put(`/category/shipment-requests/${requestId}/confirm-shipment`, null, { 
    params: { remarks } 
  });
  return response.data;
};

// =====================================================
// ITEM MASTER CASCADING FILTERS
// =====================================================

export const getItemCategories = async () => {
  const response = await apiClient.get('/category/item-master/categories');
  return response.data;
};

export const getItemDesigns = async (params = {}) => {
  const response = await apiClient.get('/category/item-master/designs', { params });
  return response.data;
};

export const getItemSizes = async (designName, search = null) => {
  const response = await apiClient.get('/category/item-master/sizes', { 
    params: { design_name: designName, search } 
  });
  return response.data;
};

export const getItemShades = async (designName, size = null, search = null) => {
  const response = await apiClient.get('/category/item-master/shades', { 
    params: { design_name: designName, size, search } 
  });
  return response.data;
};

export const getItemDescriptions = async (designName, size = null, shade = null, search = null) => {
  const response = await apiClient.get('/category/item-master/descriptions', { 
    params: { design_name: designName, size, shade, search } 
  });
  return response.data;
};

export const lookupItem = async (designName, size = null, shade = null, description = null) => {
  const response = await apiClient.get('/category/item-master/lookup', { 
    params: { design_name: designName, size, shade, description } 
  });
  return response.data;
};

// =====================================================
// SECTIONS
// =====================================================

export const getSections = async () => {
  const response = await apiClient.get('/category/sections');
  return response.data;
};

// Section incoming requests
export const getSectionIncomingRequests = async (sectionName, status = null) => {
  const response = await apiClient.get(`/category/section-requests/${encodeURIComponent(sectionName)}`, {
    params: { status }
  });
  return response.data;
};

export const acknowledgeShipmentRequest = async (requestId) => {
  const response = await apiClient.put(`/category/section-requests/${requestId}/acknowledge`);
  return response.data;
};

export const completeShipmentRequest = async (requestId) => {
  const response = await apiClient.put(`/category/section-requests/${requestId}/complete`);
  return response.data;
};
